exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1MtR0UcXRR5qrQ17oJ7Uvf{float:left;margin-bottom:1.42857rem;margin-right:2.14286rem;padding-right:1rem;width:100%}._1aqRpPMJuwzqMFQhdXlJOO{color:#b4b4b4;font-size:.85714rem;font-weight:400;line-height:1.8;margin:0}.K_1FCmKb_j_w80vIXx-L3{border-bottom:.07143rem solid #ccc;font-size:1rem;margin:.4em 0;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"Detailsboard_board": "_1MtR0UcXRR5qrQ17oJ7Uvf",
	"Detailsboard_h5": "_1aqRpPMJuwzqMFQhdXlJOO",
	"Detailsboard_p": "K_1FCmKb_j_w80vIXx-L3"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./components/Detailsboard/style.postcss
// module id = 1434
// module chunks = 0